const slidedata = [{
"id": 0,
"image": require("../images/card-images/conversation.png"),
"title": "Have a Conversation",
"copy": "There are many ways to help support a friend but you can help them make the right choice. In the end, it will need to be your friend’s decision. Sometimes our friends won’t appreciate advice they don’t want to hear—especially if they're using substances —but telling the truth to help someone close to you is part of being a positive influence, even when it’s hard to do.",
"linktitle": "",
"link": ""
},
{
"id": 1,
"image": require("../images/card-images/healthy.png"),
"title": "Be Healthy & Happy",
"copy": "Low self-esteem and depression can be major triggers. It is easy to let one part of your life, such as school, friends or relationships, become overwhelming, to the point that you do not enjoy or partake in other important aspects of your life. Encourage a healthy approach to life, including good foods, regular exercise and sports.",
"linktitle": "",
"link": ""
},
{
"id": 2,
"image": require("../images/card-images/informed.png"),
"title": "Be Informed",
"copy": "Keep yourself informed about drugs and educated on the dangers of drug use. Decisions are made every day and it’s important to know some may have bigger consequences than others.",
"linktitle": "",
"link": ""
},
{
"id": 3,
"image": require("../images/card-images/risk.png"),
"title": "Know the Risk",
"copy": "The tendency toward addiction is linked to genetics, so be familiar with any parents or other family members who have struggled with addiction. If you know that you have a higher chance of becoming addicted, take extra precautions to avoid drugs and alcohol.",
"linktitle": "",
"link": ""
},
{
"id": 4,
"image": require("../images/card-images/stress.png"),
"title": "Find Ways to Cope with Stress",
"copy": "Finding coping methods such as exercise or meditation can eliminate the urge to try substances. The fact is, substances are temporary. Once the substance wears off, physical and psychological side effects only intensify feelings of anxiety.",
"linktitle": "More Tips For How To Deal With Stress",
"link": "https://www.jedfoundation.org/id-like-some-tips-to-manage-stress-and-worries/#card=1"
},
{
"id": 5,
"image": require("../images/card-images/peer-influence.png"),
"title": "Understand Peer Influence",
"copy": "When it comes to peer pressure, friends can have a positive or negative influence on the decisions you make. It’s important to understand it is tough to be the only one who says 'no' to peer pressure, but you can do it. Paying attention to your feelings and beliefs can help you know the right thing to do when it comes to alcohol and drugs. Inner strength and self-confidence can help you stand firm, walk away, and resist.",
"linktitle": "",
"link": ""
},
{
"id": 6,
"image": require("../images/card-images/addiction.png"),
"title": "Understand Addiction",
"copy": "Being addicted to a substance can happen – even after the first time. Use of tobacco/nicotine, alcohol and other drugs during teen years interferes with brain development, reduces academic performance and increases the risk of serious health conditions.",
"linktitle": "",
"link": ""
},
{
"id": 7,
"image": require("../images/card-images/goals.png"),
"title": "Determine your Goals",
"copy": "The use of tobacco/nicotine, alcohol and other drugs can stand in the way of your short-term and long-term goals. It’s important to define your goals and understand what you can do to protect what you value most. ",
"linktitle": "",
"link": ""
}];
        
export default slidedata;


// WEBPACK FOOTER //
// ./src/data/slidecards.js